const useCheckedCount = (list) => {
    // console.log(list);
    const listKeys = Object.keys(list);
    const checkedList = listKeys.reduce((acc, msgUid) => {
        const item = list[msgUid];
        if (item.checked === true) {
            acc.push({ msgUid, msgFolder: item.msgFolder });
        }
        return acc;
    }, []);

    return {
        checkedList,
        checkedLength: checkedList.length,
        listLength: listKeys.length
    };
};

export default useCheckedCount;
